import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Search, Droplets, Clock, CreditCard } from 'lucide-react';
const features = [{
  icon: <Search className="w-6 h-6" data-id="element-142" />,
  title: 'La Cacería de Tuberías Rotas',
  description: 'Cómo encontrar tus primeros $100 USD perdidos en suscripciones y gastos fantasma que ni siquiera sabías que tenías.'
}, {
  icon: <Droplets className="w-6 h-6" data-id="element-143" />,
  title: 'El Sistema de las 3 Cubetas',
  description: 'La forma automática de separar tu dinero para Vida, Paz y Disfrute. Gasta en lo que amas sin sentir culpa.'
}, {
  icon: <Clock className="w-6 h-6" data-id="element-144" />,
  title: "La Calculadora de 'Horas de Vida'",
  description: 'El truco psicológico definitivo que detiene el 50% de tus compras impulsivas antes de que sucedan.'
}, {
  icon: <CreditCard className="w-6 h-6" data-id="element-145" />,
  title: 'Protocolo Saca-Deudas',
  description: 'El plan de ataque paso a paso, matemático y emocional, para ver los saldos de tus tarjetas en $0.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ValueSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#0f172a]" data-id="element-146">
      <div className="max-w-5xl mx-auto" data-id="element-147">
        <div className="text-center mb-16" data-id="element-148">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl font-serif font-bold text-white mb-4" data-id="element-149">
            ¿QUÉ RECIBES POR $199 MXN?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-brand-accent font-medium text-lg tracking-wide uppercase" data-id="element-150">
            El Método de George Capital Coaching
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-151">
          {features.map((feature, index) => <motion.div key={index} variants={itemVariants} className="bg-brand-card p-8 rounded-2xl border border-slate-800 hover:border-brand-accent/50 transition-colors group" data-id="element-152">
              <div className="w-12 h-12 bg-brand-dark rounded-xl flex items-center justify-center text-brand-accent mb-6 group-hover:scale-110 transition-transform border border-slate-800 group-hover:border-brand-accent/30" data-id="element-153">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3 font-serif" data-id="element-154">
                {feature.title}
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-155">
                {feature.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}